import { Home, LocationCity, StackedBarChart, WarningAmber, WaterDrop } from '@mui/icons-material';

export const menuIcons = {
    Home,
    LocationCity,
    StackedBarChart,
    WaterDrop,
    WarningAmber,
};
